import { Injectable } from '@angular/core'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { ValidationService } from '@app/shared/services/validation.service'
import { SavedQuery } from '@app/modules/saved-query/saved-query.model'

@Injectable()

export class SavedQueryFormService {

  /**
   * Insert vaildators
   */
  public insertValidators: Array<any> = [
    {
      name: [
        ValidationService.noWhiteSpace,
        ValidationService.noEmojis,
        Validators.maxLength(191),
        Validators.required
      ]
    },
    {
      description: [
        ValidationService.noWhiteSpace,
        ValidationService.noEmojis,
        Validators.maxLength(65535)
      ]
    },
    {
      jsQuery: [
        ValidationService.noWhiteSpace,
        ValidationService.noEmojis,
        Validators.maxLength(65535),
        Validators.required
      ]
    },
    {
      sqlQuery: [
        ValidationService.noWhiteSpace,
        ValidationService.noEmojis,
        Validators.maxLength(65535)
      ]
    }
  ]

  /**
   * Update validators
   */
  public updateValidators: Array<any> = [
    {
      uuid: [
        Validators.required,
        ValidationService.isUuid
      ]
    }
  ]

  /**
   * Constructor
   */
  public constructor (
    private formBuilder: FormBuilder,
    public validationService: ValidationService
  ) {}

  /**
   * Get form
   */
  public getForm (savedQuery: SavedQuery, type: string): FormGroup {
    const form: FormGroup = this.formBuilder.group({
      uuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      name: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.maxLength(191)
        ]
      ],
      description: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.maxLength(65535)
        ]
      ],
      jsQuery: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.maxLength(65535)
        ]
      ],
      sqlQuery: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.maxLength(65535)
        ]
      ],
      // Info.
      createdAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      updatedAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      deletedAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      createdByUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      updatedByUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ]
    })

    if (type === 'new') {
      this.validationService.addInsertValidators(form, this.insertValidators)
    }

    if (type === 'edit') {
      this.validationService.addUpdateValidators(form, this.insertValidators, this.updateValidators)
    }

    // Patch the form.
    if (savedQuery) {
      form.patchValue(savedQuery, { emitEvent: false })
    }

    return form
  }

}
